import { useEffect } from 'react';
import { ReactComponent as UserIcon } from '../../../../assets/icons/user.svg';
import { ReactComponent as ExitIcon } from '../../../../assets/icons/exit-icon.svg';
import s from './user.module.css';
import { useUserStore } from "../../store";
import { Link } from "react-router-dom";

export function User() {
    const userData = useUserStore((state) => state.userData);
    const getCurrentUserData = useUserStore((state) => state.getCurrentUserData);

    const logout = () => {
        localStorage.removeItem('token');
    }

    useEffect(() => {
        getCurrentUserData();
    }, [getCurrentUserData]);

    useEffect(()=>{
        if (userData?.role === "customer") {
            logout();
        }
    }, []);

    return (
        <div className={s.user}>
            <UserIcon className="d-none d-lg-block userIcon" />
            <div className={s.userInfo}>
                <span className={s.userName}>
                    {userData?.name || userData?.login || 'Неизвестный пользователь'}
                </span>
                <span className={s.userRole}><Link className={s.navItemLink} to="/"
                    onClick={() => logout()}><ExitIcon/></Link>
                </span>
            </div>
        </div>
    );
}
